export default __webpack_public_path__ + "99cf504.png";